import { Deserializable } from '../../protocols/deserializable';

export class PartialMenuRequest implements Deserializable {
  constructor(
    public variantIds: string[],
    public sectionIds: string[]
  ) {}
  onDeserialize() {}
}
